import { Components, Theme } from '@mui/material';
import { ModalRoot } from './ModalRoot';

export const MuiModal = {
  defaultProps: {
    disableEnforceFocus: true,
    slots: {
      root: ModalRoot,
    },
  },
} as Components<Theme>['MuiModal'];
